<template>
  <!-- 表单组件大小设置
       @author: liuguisheng
       @date: 2019-11-6
   -->
  <div class="setting-item">
    <el-form-item label="组件尺寸"> 
      <el-radio-group v-model="formSettingState.componentSize"
                      size="small">
        <el-radio-button  v-for="(el,index) in componentSizeList"
                          :key="index"
                          :label="el.label"> {{el.value}}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
/** 配置数据 ::: 
 *  @param {Array<Object>} componentSizeList 组件尺寸配置列表
 */
import { componentSizeList } from '@/assets/js/config_dictionary.js';
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级混入
 */
import { mixRiceIndexChild } from '@/mixins/rice_index/mix_rice_index_child.js';


export default {
  mixins: [ mixRiceIndexChild ],
  data () {
    return {
      // 组件尺寸配置字典
      componentSizeList
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/form_setting/SettingComponentSize.vue